module.exports = __webpack_public_path__ + "img/timg4.b399a198.png";